import useGlobal from '../../../../store';
import { ReactComponent as RubBtn } from './icons/rub.svg'
import { ReactComponent as CnyBtn } from './icons/cny.svg'
import { ReactComponent as UsdBtn } from './icons/usd.svg'
import { ReactComponent as EurBtn } from './icons/eur.svg'
import cssIf from '../../../../scripts/helpers/class.add.if';
import HeaderSlash from '../header.slash';
import { CURRENCY } from '../../../../settings/constants';

const CurrencyPicker = () => {

  const [ globalState, globalActions ] = useGlobal();
  const { currency } = globalState;
  const { deals } = globalActions;

  return (

    <div className = "currency_picker flex">

      <HeaderSlash />

      <RubBtn 
        
        onClick = { () => deals.changeCurrency( CURRENCY.rub )}
        className = {`${ cssIf( currency === CURRENCY.rub, "selected" ) }`} 
        title = 'Выбрать валюту "рубль" для сделок, и показать только сделки в рублях'

      />
      
      <HeaderSlash />

      <CnyBtn 
        
        onClick = { () => deals.changeCurrency( CURRENCY.cny )}
        className = {`${ cssIf( currency === CURRENCY.cny, "selected" ) }`} 
        title = 'Выбрать валюту "юань" для сделок, и показать только сделки в юанях'

      />
      
      <HeaderSlash />

      <UsdBtn 
        
        onClick = { () => deals.changeCurrency( CURRENCY.usd )}
        className = {`${ cssIf( currency === CURRENCY.usd, "selected" ) }`} 
        title = 'Выбрать валюту "доллар" для сделок, и показать только сделки в долларах'

      />
      
      <HeaderSlash />

      <EurBtn 
        
        onClick = { () => deals.changeCurrency( CURRENCY.eur )}
        className = {`${ cssIf( currency === CURRENCY.eur, "selected" ) }`} 
        title = 'Выбрать валюту "евро" для сделок, и показать только сделки в евро'

      />
      
      <HeaderSlash />

    </div>

  );

}

export default CurrencyPicker;